export const BOARD_TAB_TAGS_MAX_QUANTITY = 10;
export const BOARD_TAB_QUALIFIERS_MAX_QUANTITY = 5;
export const BOARD_TAB_TAGS_LABEL = 'Tags';
export const BOARD_TAB_QUALIFIERS_LABEL = 'Qualifiers';
export const BOARD_TAB_TAGS_SEARCH_PLACEHOLDER = 'Rechercher un tag';
export const BOARD_TAB_QUALIFIERS_SEARCH_PLACEHOLDER =
  'Rechercher un qualifier';
